import _ from "lodash";

const flatDiagram = (_diagram) => {
    const flatBlock = (block, parent, path) => {
        if (block) {
            block.path = path;
            block.parent = parent;
            block.isFlow = block.type === "FLOW";
            const items = [
                block,
                ...block.children
                    .map((childBlock, i) =>
                        !!childBlock
                            ? flatBlock(childBlock, block, `${path}${path === "" ? "" : "."}children[${i}]`)
                            : null
                    )
                    .filter(Boolean),
            ];
            return _.flatten(items);
        } else {
            return [];
        }
    };
    const diagram = _.cloneDeep(_diagram);
    let blocks = _.flatten(flatBlock(diagram, null, ""));
    return [...blocks];
};

export default flatDiagram;
